import { Component, OnInit } from '@angular/core';
declare function StartFlash(): any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  flashPlayed: boolean = false;
  constructor() { }

  ngOnInit(): void {

    if (this.flashPlayed == false) {
        
      StartFlash();
    } else
    {
      StartFlash(); // always play it
    }
    this.flashPlayed = true;

  }

}
